import Image from 'next/image';
import { FC, PropsWithChildren } from 'react';

type BulletProps = PropsWithChildren;

const Bullet: FC<BulletProps> = ({ children }) => (
  <li className={`text-h-x6 xl:text-h-x5`}>
    <div className="flex">
      <Image
        className="h-[32px] md:h-[40px] w-auto mr-4"
        src="https://images.ctfassets.net/0sea1vycfyqy/17FfSAhtv9Xc9gtKtF14dy/8a58ff35d037f0c6e4fc89c43000273e/Green_CheckMark_Brushstroke_Active.png"
        alt="bullet check"
        width={40}
        height={32}
        loading="lazy"
      />
      <div>{children}</div>
    </div>
  </li>
);

export default Bullet;
